module.exports = __webpack_public_path__ + "img/weddingRingsFacettedConnections-emotion-01.4e2a27d.jpg";